/**
 *
 * AuthenticatedRoute
 *
 */

import React, { useContext } from 'react'; //useContext, //useEffect, //useState,
import { Route, Redirect, withRouter, matchPath } from 'react-router-dom';
import { compose } from 'redux';
import { AuthContext } from 'ui/containers/Providers/AuthProvider';
import { useConfig } from 'config.js';
import routeTemplates from 'common/route-templates';
import queryString from 'query-string';
import PageLoader from 'ui/components/Loaders/PageLoader';

/**
 * @param {element} WrapComponent
 * @param authenticated - a bool base on token provided value from AuthProvider
 *
 * @return
 * render route if authenticated === true else redirect to '/register'
 */
export const AuthenticatedRoute = ({
  component: WrapComponent,
  isAuthorized = true,
  ...others
}) => {
  const { authenticated } = useContext(AuthContext);
  const { config, loading } = useConfig();
  const { DOZI_INBOX_URL } = config;

  // Show loading spinner while config is being fetched
  if (loading) {
    return (
      <div>
        <PageLoader />
      </div>
    );
  }
  const { location } = others;
  const searchParams = queryString.parse(window.location.search);
  const redirectUrl = searchParams.redirectUrl;
  const redirectPath =
    routeTemplates.login +
    `?redirectUrl=${redirectUrl || encodeURIComponent(location.pathname + location.search)}`;
  const isInboxRoot = matchPath(location.pathname, {
    path: routeTemplates.project.inbox.root,
  });
  const isInboxDetail = matchPath(location.pathname, {
    path: routeTemplates.project.inbox.detail,
  });
  if (
    window.appDetails.isDoziCustomer &&
    !window.appDetails.migrationInProgress &&
    !window.appDetails.isInsideMSTeams &&
    !window.appDetails.user.isCSUser &&
    (isInboxRoot || isInboxDetail)
  ) {
    window.location.href = `${DOZI_INBOX_URL}`;
    return (
      <div>
        <PageLoader />
      </div>
    );
  } else {
    return (
      <Route
        {...others}
        render={routeProps =>
          authenticated ? (
            isAuthorized ? (
              <WrapComponent {...routeProps} />
            ) : (
              <Redirect to={routeTemplates.notAuthorized} />
            )
          ) : (
            <Redirect to={redirectPath} />
          )
        }
      />
    );
  }
};

export default compose(withRouter)(AuthenticatedRoute);
